import React, {Component} from "react";
import { ListTabButton } from "../list-tab/list-tab-button.component";
import "./history.component.css";
import ButtonIcon from "../../button";
import { CustomColumns } from "../../common/modal-popover/custom-columns";
export class HistoryLayout extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            updatedDisplaySearch: false
        };
      }

      FilterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex}); 
        this.props.selectedIndex(tabIndex)
     }

     DisplaySearhBox() {
        this.setState(prevState => {
            const updatedDisplaySearch = !prevState.displaySearch;
            this.props.displaySearchBox(updatedDisplaySearch);
            return {displaySearch: updatedDisplaySearch};
        });
    }

    render(){
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite, isViewing } = this.props;
        return(
            <div className="history-main-container">
                {this.props.listHistoryTab? <ListTabButton listData={this.props.listHistoryTab} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/> : null}                              
                <div className="button-header__alignment">
                    <ButtonIcon isDisable={isViewing ? true : false} onClick={this.DisplaySearhBox.bind(this)} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>
                    {!this.props.listHistoryTab && !this.props.hideCustomColumn ? <CustomColumns 
                            firstList={this.props.firstList ? this.props.firstList : []} 
                            secondList={this.props.secondList ? this.props.secondList : []} 
                            defaultList={this.props.defaultList ? this.props.defaultList :[]} 
                            saveAction={this.props.saveAction}/> : null }
                        <ButtonIcon
                            onClick={(isReadAndExtractOnly || isReadAndWrite) ? () => this.props.extractAction() : () => { }}
                            iconLeft="cloud-arrow-down" iconSize="17px"
                            customClassName={`${!this.props.isReadOnly ? "header-option-list" : ""} header-filter-button`}
                            isDisable={isViewing || (isReadOnly && !isReadAndExtractOnly && !isReadAndWrite)}
                            labelName="Extract List"/> 
                </div> 
                {this.props.children}
            </div>
        )
    }
}